import { createSlice } from "@reduxjs/toolkit";
import apiSlice from "./apiSlice";
import type { Game, Player } from "../types/game";


interface GameState {
    game: Game | null;
    player: Player | null;
}

const initialState: GameState = {
    game: null,
    player: null,
};

const gameSlice = createSlice({
    name: "game",
    initialState,
    reducers: {
        setGame: (state, action) => {
            state.game = action.payload;
        },
        setPlayer: (state, action) => {
            state.player = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addMatcher(apiSlice.endpoints.getPlayer.matchFulfilled,
            (state, {payload}) => {
                console.log(payload)
                state.player = payload.player
                if (state.player) {
                    state.player.round_updates = payload.round_updates
                }
            }
        ),
        builder.addMatcher(apiSlice.endpoints.getGame.matchFulfilled,
            (state, {payload}) => {
                state.game = payload
            }
        ),
        builder.addMatcher(apiSlice.endpoints.assignRole.matchFulfilled,
            (state, {payload}) => {
                if (state.game) {
                    state.game.players = payload.players
                }
            }
        ),
        builder.addMatcher(apiSlice.endpoints.startGame.matchFulfilled,
            (state, {payload}) => {
                state.game = payload
            }
        ),
        builder.addMatcher(apiSlice.endpoints.updatePlayer.matchFulfilled,
            (state, {payload}) => {
                if (state.game) {
                    state.game.players = state.game.players.map(player => player.objectId === payload.objectId ? payload : player)
                }
            }
        ),
        builder.addMatcher(apiSlice.endpoints.randomAssign.matchFulfilled,
            (state, {payload}) => {
                if (state.game) {
                    state.game.players = payload.players
                }
            }
        ),
        builder.addMatcher(apiSlice.endpoints.advance.matchFulfilled,
            (state, {payload}) => {
                state.game = payload.game
            }
        )
    }
});

export const { setGame, setPlayer } = gameSlice.actions;
export default gameSlice.reducer;